import { useCallback, useEffect, useState } from 'react';
import { SpeakerSuggestions } from '../speaker-suggestions';
import { useSpeakersContext } from './speakers-context';
export const useSpeakerSuggestions = () => {
    const { queryDocumentSpeakers, projectLanguage, diarizationCode } = useSpeakersContext();
    const [speakerSuggestions] = useState(() => new SpeakerSuggestions(projectLanguage, diarizationCode, queryDocumentSpeakers, () => { }));
    const [speakers, setSpeakers] = useState([]);
    const pushQuery = useCallback((searchText, scope) => {
        setSpeakers('loading');
        speakerSuggestions.pushQuery(searchText, scope);
    }, [speakerSuggestions]);
    useEffect(() => {
        const handleSuggestions = (speakerNodes) => {
            setSpeakers(speakerNodes);
        };
        speakerSuggestions.onReceivedSuggestions(handleSuggestions);
        return () => {
            speakerSuggestions.offReceivedSuggestions();
            speakerSuggestions.close();
        };
    }, [speakerSuggestions]);
    return [pushQuery, speakers];
};
// const useSpeakerSuggestions = ({
//   speakerSuggestionWebSocket,
//   language,
//   editorController,
//   diarizationCode,
//   onClose,
//   documentSpeakersOnly = false,
// }: Params): SpeakerSuggestions => {
//   const resolveSuggestionQueue = useRef<((value: string) => void)[]>([]);
//   const isLostConnectionHandled = useRef(false);
//   console.log('useSpeakerSuggestions', isLoading);
//   const handleSuggestionMessage = ({ data }: SuggestionMessage): void => {
//     const resolveSuggestion = resolveSuggestionQueue.current.shift();
//     if (resolveSuggestion !== undefined) {
//       resolveSuggestion(data);
//     }
//   };
//   if (!documentSpeakersOnly) {
//     speakerSuggestionWebSocket?.setOnMessage(handleSuggestionMessage);
//   }
//   const getSuggestions = async (prefix: string): Promise<string> => {
//     try {
//       speakerSuggestionWebSocket?.sendQuery(
//         prefix,
//         language?.code ?? '',
//       );
//     } catch {
//       return '[]';
//     }
//     const responseMessage = await new Promise<string>((resolve) => {
//       resolveSuggestionQueue.current.push(resolve);
//     });
//     return responseMessage;
//   };
//   const loadSpeakers = useCallback(async (searchText: string): Promise<SpeakerNode[]> => {
//     console.log('loadSpeakers', searchText);
//     if (searchText === '') {
//       return [];
//     }
//     try {
//       const filteredDocumentSpeakers = editorController.speakers.documentSpeakers.filter(
//         (speaker) => {
//           if (searchText === '' && speaker.isUnknown) {
//             return false;
//           }
//           return speaker.matches(searchText);
//         },
//       );
//       const docNodes = getSpeakerNodesFromDocument(filteredDocumentSpeakers);
//       if (documentSpeakersOnly) {
//         return docNodes;
//       }
//       const responseMessage = await Promise.race([
//         getSuggestions(searchText),
//         new Promise<never>((_resolve, reject) => {
//           setTimeout(() => { reject(new Error('timeout')); }, 10000);
//         }),
//       ]);
//       const speakerDataList = parseSpeakerDataResponse(JSON.parse(responseMessage) ?? []);
//       const locale = language?.code;
//       const dbNodes = getSpeakerNodesFromDb(
//         speakerDataList.map((s) => ({ ...s.speaker, variantPaths: s.variantPaths })),
//         locale,
//         true,
//       )
//         .map((node) => ({ ...node, diarizationCode }));
//       return getSortedNodes(dbNodes, docNodes);
//     } catch (error) {
//       if (error instanceof Error && error.message === 'timeout') {
//         if (isLostConnectionHandled.current) {
//           return [];
//         }
//         isLostConnectionHandled.current = true;
//         void message.warning(txt('lostConnection'));
//         global.logger.error('reviving speaker suggestion websocket');
//         speakerSuggestionWebSocket?.revive();
//         onClose();
//       }
//       global.logger.error('failed to load speaker suggestion', {}, error);
//       return [];
//     }
//   }, [documentSpeakersOnly, editorController, language, onClose, speakerSuggestionWebSocket]);
//   return { loadSpeakers, isLoading };
// };
// export default useSpeakerSuggestions;
